// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"99106c75","283":"a82a5a93","455":"a82a5a93","584":"7db55e1c","794":"eb98ec86","898":"e0ae165b","950":"d7bc39f0"}[chunkId] + ".chunk.css";
};